import React, { useState, useEffect } from 'react';

const SelectableBall = ({ switchToImpulseResponse1, switchToImpulseResponse2, switchToImpulseResponse3, switchToImpulseResponse4, switchToImpulseResponse5, switchToImpulseResponse6, switchToImpulseResponse7, switchToImpulseResponse8, switchToImpulseResponse9 }) => {
    const ballRadius = 20; // ボールの半径を指定
    const smallCircleRadius = 40; // 小さな円の半径を指定
    const clickableRadius = 120;
    const [pinkBallPosition, setPinkBallPosition] = useState(null); // ピンクのボールの位置を管理
    const [selectedCircleIndex, setSelectedCircleIndex] = useState(4); // デフォルトで5番目の円を選択

    // 極座標からデカルト座標への変換関数
    const polarToCartesian = (radius, azimuth) => {
        const radians = (azimuth + 90) * (Math.PI / 180); // 真上方向が0で時計回りに増加
        return {
            x: radius * Math.cos(radians),
            y: -radius * Math.sin(radians),
        };
    };

    // クリック可能な円の定義（極座標）
    const circles = [
        { radius: smallCircleRadius / 2 + 20, azimuth: 90, onClick: switchToImpulseResponse1 }, // 左側の円
        { radius: clickableRadius, azimuth: 145, onClick: switchToImpulseResponse2 },
        { radius: clickableRadius, azimuth: 90, onClick: switchToImpulseResponse3 },
        { radius: clickableRadius, azimuth: 40, onClick: switchToImpulseResponse4 },
        { radius: clickableRadius, azimuth: 0, onClick: switchToImpulseResponse5 },
        { radius: clickableRadius, azimuth: 320, onClick: switchToImpulseResponse6 },
        { radius: clickableRadius, azimuth: 270, onClick: switchToImpulseResponse7 },
        { radius: clickableRadius, azimuth: 215, onClick: switchToImpulseResponse8 },
        { radius: smallCircleRadius / 2 + 20, azimuth: 270, onClick: switchToImpulseResponse9 }, // 右側の円
    ];

    useEffect(() => {
        // デフォルトで正面の円を選択
        handleCircleClick(circles[4]);
    }, []);

    const handleCircleClick = (circle) => {
        const { x, y } = polarToCartesian(circle.radius, circle.azimuth);
        circle.onClick();
        setPinkBallPosition({ x, y });
        setSelectedCircleIndex(circles.indexOf(circle));
    };

    const handleContainerClick = (event) => {
        const rect = event.target.getBoundingClientRect();
        const x = event.clientX - rect.left - rect.width / 2;
        const y = event.clientY - rect.top - rect.height / 2;

        console.log(`Clicked at: x=${x}, y=${y}`);

        for (const circle of circles) {
            const { x: circleX, y: circleY } = polarToCartesian(circle.radius, circle.azimuth);
            if (Math.sqrt((x - circleX) ** 2 + (y - circleY) ** 2) <= ballRadius) {
                handleCircleClick(circle);
                return;
            }
        }
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            const index = parseInt(event.key, 10) - 1;
            if (index >= 0 && index < circles.length) {
                handleCircleClick(circles[index]);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [circles]);

    const renderSmallCircle = () => {
        const enlargedRadius = smallCircleRadius * 1.2; // 画像を少し大きくするために半径を1.2倍にする
        return (
            <img
            src="head.svg"
            alt="Head"
            style={{
                position: 'absolute',
                left: `calc(50% - ${enlargedRadius}px)`,
                top: `calc(50% - ${enlargedRadius}px - 5px)`,
                width: `${enlargedRadius * 2}px`,
                height: `${enlargedRadius * 2}px`,
                borderRadius: '50%',
                zIndex: 1, // Ensure the image is clickable
            }}
            />
        );
    };

    const renderMarkers = () => {
        return circles.map((circle, index) => {
            const { x, y } = polarToCartesian(circle.radius, circle.azimuth);
            return (
                <div
                    key={index}
                    style={{
                        position: 'absolute',
                        left: `calc(50% + ${x}px - ${ballRadius}px)`,
                        top: `calc(50% + ${y}px - ${ballRadius}px)`,
                        width: `${ballRadius * 2}px`,
                        height: `${ballRadius * 2}px`,
                        borderRadius: '50%',
                        border: '2px dotted #ff00ff',
                        backgroundColor: 'rgba(144, 144, 193, 0.6)', // 背景色を透過
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontSize: '12pt',
                        cursor: 'pointer',
                        zIndex: 2, // Ensure the marker is clickable
                    }}
                    onClick={() => handleCircleClick(circle)}
                >
                    {index + 1}
                </div>
            );
        });
    };

    return (
        <div className="circle-container" onClick={handleContainerClick}>
            <div className="label top-label">Front</div>
            <div className="label bottom-label">Back</div>
            <div className="label left-label">Left</div>
            <div className="label right-label">Right</div>
            <div className="inner-circle">
                <div className="crosshair"></div>
                {renderSmallCircle()}
                {renderMarkers()}
                {pinkBallPosition && (
                    <div
                        className="draggable-circle"
                        style={{
                            left: `calc(50% + ${pinkBallPosition.x}px - ${ballRadius}px)`,
                            top: `calc(50% + ${pinkBallPosition.y}px - ${ballRadius}px)`,
                            width: `${ballRadius * 2}px`,
                            height: `${ballRadius * 2}px`,
                            borderRadius: '50%',
                            border: '2px solid #333333',
                            backgroundColor: '#ff00ff', // ピンク色
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#333333', // 濃いグレー
                            fontSize: '16pt',
                            fontWeight: 'bold', // テキストを太字にする
                            zIndex: 3, // ピンクのボールが最前面に来るようにする
                        }}
                    >
                        {selectedCircleIndex + 1}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SelectableBall;